
import React, { useState, useEffect } from 'react';
import { functions } from '../../services/firebaseConnection';
import { httpsCallable } from 'firebase/functions';
import { useNavigate } from 'react-router-dom';
import './payment.css'
import LogoBarberia from '../../assets/LogoBarbearia.png';

export default function Payment() {
  const navigate = useNavigate();
  const [chargeData, setChargeData] = useState({
    name: '',
    cpf: '',
    email: '',
    birth: '',
    phoneNumber: '',
    street: '',
    number: '',
    neighborhood: '',
    zipcode: '',
    city: '',
    complement: '',
    state: '',
    cardNumber: '',
    cvv: '',
    expirationMonth: '',
    expirationYear: '',
    brand: 'mastercard',
    paymentToken: '4793d19a56f3df60e95d8d11ddfb9921ec535810'
  });
  const [isEfiJsLoaded, setIsEfiJsLoaded] = useState(false);
  const [errors, setErrors] = useState({});

  const handleCancelClick = () => {
    navigate('/homeCli');
  };


  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://cdn.jsdelivr.net/gh/efipay/js-payment-token-efi/dist/payment-token-efi.min.js";
    script.async = true;
    script.onload = () => setIsEfiJsLoaded(true);
    document.body.appendChild(script);
  }, []);

  const handleInputChange = (e) => {
    setChargeData({ ...chargeData, [e.target.name]: e.target.value });
  };

  const validateFields = () => {
    const newErrors = {};
    if (!chargeData.name) newErrors.name = 'Nome é obrigatório';
    if (!chargeData.cpf || chargeData.cpf.length !== 11) newErrors.cpf = 'CPF inválido';
    if (!chargeData.email) newErrors.email = 'E-mail é obrigatório';
    if (!chargeData.birth) newErrors.birth = 'Data de nascimento é obrigatória';
    if (!chargeData.phoneNumber) newErrors.phoneNumber = 'Telefone é obrigatório';
    if (!chargeData.street) newErrors.street = 'Rua é obrigatória';
    if (!chargeData.number) newErrors.number = 'Número é obrigatório';
    if (!chargeData.neighborhood) newErrors.neighborhood = 'Bairro é obrigatório';
    if (!chargeData.zipcode || chargeData.zipcode.length !== 8) newErrors.zipcode = 'CEP inválido';
    if (!chargeData.city) newErrors.city = 'Cidade é obrigatória';
    if (!chargeData.state) newErrors.state = 'Estado é obrigatório';
    if (!chargeData.cardNumber) newErrors.cardNumber = 'Número do cartão é obrigatório';
    if (!chargeData.cvv || chargeData.cvv.length < 3) newErrors.cvv = 'CVV inválido';
    if (!chargeData.expirationMonth) newErrors.expirationMonth = 'Mês de expiração é obrigatório';
    if (!chargeData.expirationYear) newErrors.expirationYear = 'Ano de expiração é obrigatório';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const identifyCardBrand = async () => {
    if (!isEfiJsLoaded) {
      console.error('Biblioteca EfiJs ainda não está carregada.');
      return;
    }
    try {
      const brand = await window.EfiJs.CreditCard
        .setCardNumber(chargeData.cardNumber)
        .verifyCardBrand();
      setChargeData({ ...chargeData, brand });
    } catch (error) {
      console.error('Erro ao identificar bandeira do cartão:', error);
    }
  };

  const generatePaymentToken = async () => {
    if (!chargeData.brand) {
      console.error('Bandeira do cartão não identificada.');
      return;
    }
    try {
      const tokenData = await window.EfiJs.CreditCard
        .setAccount('cdd550c19620659e0441946a2b25eb45')
        .setEnvironment('sandbox') // ou 'sandbox'
        .setCreditCardData({
          brand: chargeData.brand,
          number: chargeData.cardNumber,
          cvv: chargeData.cvv,
          expirationMonth: chargeData.expirationMonth,
          expirationYear: chargeData.expirationYear,
          reuse: false
        })
        .getPaymentToken();
      return tokenData.payment_token;
    } catch (error) {
      console.error('Erro ao gerar token de pagamento:', error);
      throw error;
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateFields()) {
      console.error('Erros de validação nos campos');
      return;
    }

    try {
      await identifyCardBrand();
      console.log('Bandeira identificada:', chargeData.brand);

      if (!chargeData.brand) {
        console.error('Bandeira do cartão não identificada.');
        return;
      }

      const paymentToken = await generatePaymentToken();
      console.log('Token de Pagamento:', paymentToken);

      if (!paymentToken) {
        console.error('Falha ao gerar o token de pagamento.');
        return;
      }

      // Atualiza o estado com o novo paymentToken
      setChargeData(prevState => ({
        ...prevState,
        paymentToken: paymentToken
      }));

      const generateToken = httpsCallable(functions, 'generateAccessToken');
      const tokenResponse = await generateToken({});
      const accessToken = tokenResponse.data.access_token;
      console.log('Access Token:', accessToken);

      // Aguarde um ciclo de renderização para garantir que o estado foi atualizado
      setTimeout(async () => {
        const createCharge = httpsCallable(functions, 'createCreditCardCharge');
        const chargeResponse = await createCharge({ ...chargeData, accessToken, paymentToken });
        console.log('Charge Response:', chargeResponse.data);
      }, 0);

    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div className="container">
      <nav className="navbar">
        <img src={LogoBarberia} alt="Logo" className="logo" />
        <div className="navbar-center">
        <h2>Pagamento com cartão</h2>

          <div className="navbar-links">
          </div>
        </div>
        <button className="logout-button"onClick={handleCancelClick}>Cancelar</button>
      </nav>
      <div className="container-pay">
        <form onSubmit={handleSubmit}>
          <div className="section-pay">
            <h3 className="section-title-pay">Dados Pessoais</h3>
            <div className="input-group">
              <div className="input-wrapper">
                <p>Nome:</p>
                <input className='input-pay' name="name" onChange={handleInputChange} placeholder="Nome Completo" />
                {errors.name && <div style={{ color: 'red' }}>{errors.name}</div>}
              </div>
              <div className="input-wrapper">
                <p>CPF:</p>
                <input className='input-pay' name="cpf" onChange={handleInputChange} placeholder="12345678909" maxLength="11" />
                {errors.cpf && <div style={{ color: 'red' }}>{errors.cpf}</div>}
              </div>
            </div>
            <div className="input-group">
              <div className="input-wrapper">
                <p>E-mail:</p>
                <input className='input-pay' name="email" onChange={handleInputChange} placeholder="Corte'sCurte@cortes.com" />
                {errors.email && <div style={{ color: 'red' }}>{errors.email}</div>}
              </div>
              <div className="input-wrapper">
                <p>Data de Nascimento:</p>
                <input className='input-pay' name="birth" onChange={handleInputChange} placeholder="00/00/0000" type="date" />
                {errors.birth && <div style={{ color: 'red' }}>{errors.birth}</div>}
              </div>
            </div>
            <div className="input-group">
              <div className="input-wrapper">
                <p>Telefone:</p>
                <input className='input-pay' name="phoneNumber" onChange={handleInputChange} placeholder="11955554444" />
                {errors.phoneNumber && <div style={{ color: 'red' }}>{errors.phoneNumber}</div>}
              </div>
              <div className="input-wrapper">
                <p>Rua:</p>
                <input className='input-pay' name="street" onChange={handleInputChange} placeholder="Rua Paraná" />
                {errors.street && <div style={{ color: 'red' }}>{errors.street}</div>}
              </div>
            </div>
            <div className="input-group">
              <div className="input-wrapper">
                <p>Número do endereço:</p>
                <input className='input-pay' name="number" onChange={handleInputChange} placeholder="32" />
                {errors.number && <div style={{ color: 'red' }}>{errors.number}</div>}
              </div>
              <div className="input-wrapper">
                <p>Bairro:</p>
                <input className='input-pay' name="neighborhood" onChange={handleInputChange} placeholder="Montanhão" />
                {errors.neighborhood && <div style={{ color: 'red' }}>{errors.neighborhood}</div>}
              </div>
            </div>
            <div className="input-group">
              <div className="input-wrapper">
                <p>CEP:</p>
                <input className='input-pay' name="zipcode" onChange={handleInputChange} placeholder="09785015" />
                {errors.zipcode && <div style={{ color: 'red' }}>{errors.zipcode}</div>}
              </div>
              <div className="input-wrapper">
                <p>Cidade:</p>
                <input className='input-pay' name="city" onChange={handleInputChange} placeholder="São Bernardo do Campo" />
                {errors.city && <div style={{ color: 'red' }}>{errors.city}</div>}
              </div>
            </div>
            <div className="input-group">
              <div className="input-wrapper">
                <p>Estado:</p>
                <input className='input-pay' name="state" onChange={handleInputChange} placeholder="SP" />
                {errors.state && <div style={{ color: 'red' }}>{errors.state}</div>}
              </div>
            </div>
          </div>
          <div className="section-pay">
            <h3 className="section-title-pay">Dados do Cartão</h3>
            <div className="input-group">
              <div className="input-wrapper">
                <p>Número do Cartão:</p>
                <input className='input-pay' name="cardNumber" onChange={handleInputChange} placeholder="XXXX XXXX XXXX XXXX" />
                {errors.cardNumber && <div style={{ color: 'red' }}>{errors.cardNumber}</div>}
              </div>
              <div className="input-wrapper">
                <p>Código do Cartão:</p>
                <input className='input-pay' name="cvv" onChange={handleInputChange} placeholder="CVV" />
                {errors.cvv && <div style={{ color: 'red' }}>{errors.cvv}</div>}
              </div>
            </div>
            <div className="input-group">
              <div className="input-wrapper">
                <p>Mês de Expiração:</p>
                <input className='input-pay' name="expirationMonth" onChange={handleInputChange} placeholder="01" />
                {errors.expirationMonth && <div style={{ color: 'red' }}>{errors.expirationMonth}</div>}
              </div>
              <div className="input-wrapper">
                <p>Ano de Expiração:</p>
                <input className='input-pay' name="expirationYear" onChange={handleInputChange} placeholder="2025" />
                {errors.expirationYear && <div style={{ color: 'red' }}>{errors.expirationYear}</div>}
              </div>
            </div>
          </div>
          <button className="button-pay" type="submit">Finalizar Pagamento</button>
        </form>
      </div>
    </div>

  );
}  